// @flow
// TODO redo using react.lazy / Suspense. Probably.
import React, { PureComponent } from 'react'
import { DisplacementArrow } from 'components/displacementArrow'
import './styles.scss'
import { Waypoint } from 'react-waypoint'
import { categories } from '../../global/categories'

const gradient = categories
const OFFSET = '-25%'

type Props = {
  category: string,
  current: string,
  previous: string,
  imageName: string,
}

type State = {
  src?: string,
  srcSet?: string,
}

export class TopImage extends PureComponent<Props, State> {
  state = {}

  componentDidMount() {
    if (this.props.imageName && this.props.imageName !== '') {
      import(
        /* webpackMode: "lazy-once" */
        /* webpackChunkName: "placeholder" */
        `images/hotels/${this.props.imageName}.jpg?placeholder`
      )
        .then((obj) => {
          obj.placeholder && this.setState({ src: obj.placeholder.url })
        })
        .catch((error) => {
          console.warn("🖼️ couldn't find placeholder for", this.props.imageName)
        })
    }
  }

  render() {
    const topImageStyles = {
      backgroundColor: gradient[this.props.category][2],
    }
    try {
      return (
        <Waypoint
          onEnter={() => {
            if (this.props.imageName && this.props.imageName !== '') {
              import(
                /* webpackMode: "lazy" */
                /* webpackChunkName: "hotel" */
                `images/hotels/${this.props.imageName}.jpg?sizes=175w+350w+700w+1024w`
              ).then((obj) => {
                obj.sources &&
                  this.setState({
                    src: obj.sources['350w'],
                    srcSet: obj.srcSet,
                  })
              })
            }
          }}
          scrollableAncestor={window}
          topOffset={OFFSET}
          bottomOffset={OFFSET}
        >
          <div className='top image' style={topImageStyles}>
            {this.props.imageName && (
              <div
                style={{
                  position: 'relative',
                }}
              >
                <img
                  className='ui fluid image'
                  src={require('../../images/hotels/' +
                    this.props.imageName +
                    '.jpg')}
                />
                {/*
              <img
                className='ui fluid image'
                {...this.state}
                alt=''
                sizes={
                  '(max-width:' +
                  ' 599px) 95vw, (max-width: 899px) 45vw, (max-width: 1199px) 32vw, 700px'
                }
              />
              */}
              </div>
            )}
            <div
              className='rank-container'
              style={{
                backgroundImage: !this.state.src
                  ? undefined
                  : `linear-gradient(
                  135deg,
                  rgba(32, 35, 70,0) 0%,
                  rgba(32, 35, 70,0) 50%,
                  rgba(32, 35, 70,0.8) 90%)`,
              }}
            >
              <div className='rank'>
                <div className='previous-rank'>
                  {this.props.previous ? this.props.previous : 'neu'}
                  <DisplacementArrow
                    current={this.props.current}
                    previous={this.props.previous}
                  />
                </div>
                <div className='ui huge infographic inverted header'>
                  {this.props.current}
                </div>
              </div>
            </div>
          </div>
        </Waypoint>
      )
    } catch (error) {
      console.warn("🖼️ couldn't find image for", this.props.imageName)
      return <></>
    }
  }
}
